import { useState } from "react";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";

export default function CarrierLogo({ operatorId, size = 40 }) {
    const [hasError, setHasError] = useState(false);
    const src = operatorId ? `/assets/logo/${operatorId}.png` : null;

    if (!src || hasError) {
        return (
            <Box
                sx={{
                    width: size,
                    height: size,
                    borderRadius: 2,
                    bgcolor: "grey.100",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    border: "1px solid",
                    borderColor: "grey.200",
                }}
            >
                <Icon icon="mdi:bus" width={size * 0.5} color="#919EAB" />
            </Box>
        );
    }

    return (
        <Box
            sx={{
                width: size,
                height: size,
                borderRadius: 2,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "white",
                boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
                overflow: "hidden",
            }}
        >
            <Box
                component="img"
                src={src}
                alt=""
                onError={() => setHasError(true)}
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                }}
            />
        </Box>
    );
}
